import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SedsOutlinedButtonComponent } from './seds-outlined-button.component';

import { SedsCoreButtonModule } from '../../seds-buttons/seds-core-button/seds-core-button.module';

@NgModule({
  declarations: [SedsOutlinedButtonComponent],
  imports: [CommonModule, SedsCoreButtonModule],
  exports: [SedsOutlinedButtonComponent],
})
export class SedsOutlinedButtonModule {}
